const errorMessage = '해당하는 타입에 매칭되는 정보가 없습니다.';

const notFound = (type) => {
  return `${type}에 해당하는 정보가 없습니다.`
}

/*
    public enum WalletTransactionType
    {
        NONE = 0,
        TRANSFER = 11,
        BURN, // AccountBookWallet.Burn
        WITHDRAW, // TargetWalletNo = 0
        WITHDRAW_ONCHAIN,
        BURN_FEE_TRANSACTION = 15, // AccountBookWallet.TransactionFee
        BURN_FEE_PLAY, // AccountBookWallet.GameplayFee
        BURN_FEE_ROYALTY, // AccountBookWallet.RoyaltyFee
        BURN_FEE_ETC, // AccountBookWallet.EtcFee
        MINT = 21, // SourceWalletNo = 0
        DEPOSIT, // SourceWalletNo = 0
        DEPOSIT_ONCHAIN,

        NftLevelup = 101,
        NftLevelupBoost,
        NftRepair,
        NftRestore,
        OpenSpecialBox,
        RewardSpecialBox,
        NftRental,
        NftDisassemble,

        NftBreed = 111,
        NftEvolve,
        GemUpgrade,
        RollRandomGemSocket,
        ResetStatPoints,
        NicknameChange,

        BuyNft = 121,
        SellNft,
        BuyItem,
        SellItem,

        MiningDeposit = 130,
        PostReceive = 131,
        MiningWithdraw,

        EventDeposit = 140,
        EventBurn,

        // 베이직 모드 일일 미션 보상 수령
        BASIC_MODE_DAILY_MISSION_DEPOSIT = 150,
        BASIC_MODE_DAILY_MISSION_WITHDRAW = 151,
        // 베이직 모드 일회성 미션 보상 수령
        BASIC_MODE_ONETIME_MISSION_DEPOSIT = 152,
        BASIC_MODE_ONETIME_MISSION_WITHDRAW = 153,
        // 다른 사람의 레퍼럴 코드를 입력하면 즉시 받는 입력 보상 수령
        BASIC_MODE_CODE_INPUT_DEPOSIT = 154,
        BASIC_MODE_CODE_INPUT_WITHDRAW = 155,
        // 전날 친구들이 쌓아준 선물 항아리의 보상 수령
        BASIC_MODE_FRIEND_GIFT_DEPOSIT = 156,
        BASIC_MODE_FRIEND_GIFT_WITHDRAW = 157,
        // 누적 친구 초대 수에 따른 미션 보상 수령 (10명, 20명, 50명.. 초대했을 때 받는 보상)
        BASIC_MODE_INVITE_MISSION_DEPOSIT = 158,
        BASIC_MODE_INVITE_MISSION_WITHDRAW = 159,

        ITEM_BOX_REWARD_DEPOSIT = 170,
        ITEM_BOX_REWARD_WITHDRAW = 171,

        EVENT_RAFFLE_REWARD_DEPOSIT = 300,
        EVENT_RAFFLE_REWARD_WITHDRAW = 301,
        EVENT_RAFFLE_USE_TOKEN = 302,
    }
 */

export const walletTransactionType = {
  0: '-',
  11: '전송',
  12: '소각',
  13: '인출',
  14: '온체인 인출',
  15: '소각 수수료(전송)',
  16: '소각 수수료(플레이)',
  17: '소각 수수료(로열티)',
  18: '소각 수수료(기타)',
  21: '민팅',
  22: '예치',
  23: '온체인 예치',
  101: '차량 레벨업',
  102: '차량 레벨업 가속',
  103: '차량 수리',
  104: '차량 복원',
  105: '스페셜 상자 열기',
  106: '스페셜 상자 오픈 보상',
  107: '렌탈',
  108: '분해',
  111: '브리드',
  112: '이볼브',
  113: '보석 업그레이드',
  114: '보석 소켓 변경',
  115: 'NFT 스탯 초기화',
  116: '닉네임 변경',
  117: '엔진 업그레이드',
  121: 'NFT 구입',
  122: 'NFT 판매',
  123: '아이템 구입',
  124: '아이템 판매',
  130: '채굴(유저)',
  131: '우편 보상 수령',
  132: '채굴(관리지갑)',
  140: '이벤트 보상 획득',
  141: '이벤트 참여 소모',
  150: '베이직 모드 일일 미션 보상 수령',
  151: '베이직 모드 일일 미션 소모',
  152: '베이직 모드 일회성 미션 보상 수령',
  153: '베이직 모드 일회성 미션 소모',
  154: '다른 사람의 레퍼럴 코드를 입력하면 즉시 받는 입력 보상 수령',
  155: '다른 사람의 레퍼럴 코드를 입력하면 즉시 받는 입력 보상 소모',
  156: '전날 친구들이 쌓아준 선물 상자의 보상 수령',
  157: '전날 친구들이 쌓아준 선물 상자의 보상 소모',
  158: '누적 친구 초대 수에 따른 미션 보상 수령',
  159: '누적 친구 초대 수에 따른 미션 보상 소모',
  170: '아이템 상자 보상 수령',
  171: '아이템 상자 보상 소모',
  300: '이벤트 래플 보상 수령',
  301: '이벤트 래플 보상 소모',
  302: '이벤트 래플 사용',
  142: '이벤트로 인한 지급',
  400: '파일럿 장착/제거',
  401: '파일럿 스킬 수치 변경',
  402: '파일럿 승급',
  403: '파일럿 코어 변환'
};

/*
        /// <summary>
        /// 우편 획득
        /// </summary>
        PostReceive = 1,
        /// <summary>
        /// 파워 충전 사용
        /// </summary>
        PowerCharge = 100,
        /// <summary>
        /// 파워 저장소 업그레이드
        /// </summary>
        StoredPowerUpgrade = 101,
        /// <summary>
        /// 렌탈 티켓 사용
        /// </summary>
        UseRentalTicket = 102,
        /// <summary>
        /// NFT 배경 이미지 변경
        /// </summary>
        NftBackgroundChange = 103,
        /// <summary>
        /// 캠페인 VIP 티켓 사용
        /// </summary>
        UseCampaignVipTicket = 104,
        /// <summary>
        /// 캠페인 VIP 티켓 획득
        /// </summary>
        GetContentsReward = 105,
        ItemShop = 106,
        ItemShopRollBack = 107,
        /// <summary>
        /// NFT 레벨업 가속 아이템 사용
        /// </summary>
        NftLevelUpBoost = 108,
        /// <summary>
        /// NFT 브리딩 카운트 감소 아이템 사용
        /// </summary>
        DecreaseBreedCount = 109,


        ItemBoxAllPackageBox = 201,
        ItemBoxRateBox = 202,
        ItemBoxSelectBox = 203,
        ItemBoxMultipleBox = 204,
        EventRaffleUse = 300,
        EventRaffleReward = 301,

        EngineEnhanceTarget = 400, // 강화대상 엔진
        EngineEnhanceParts = 401,
        EngineEnhanceProtector = 402,
        EngineEnhanceResult = 403,
        EngineSuccessSupporter = 404,
* */
export const itemTransactionType = {
  1: '우편 획득',
  100: '파워 충전 사용',
  101: '파워 저장소 업그레이드',
  102: '렌탈 티켓 사용',
  103: 'NFT 배경 변경',
  104: '캠페인 VIP 티켓 사용',
  105: '콘텐츠 보상 획득',
  106: '아이템 상점 구매',
  107: '아이템 상점 철회',
  108: 'NFT 레벨업 가속 아이템 사용',
  109: 'NFT 브리딩 카운트 감소 아이템 사용',
  110: '워크샵 브리드',
  111: '워크샵 이볼브',
  112: '워크샵 젬 업그레이드',
  113: '레벨업',
  114: '스탯 초기화',
  115: '복원',
  201: '아이템 상자(전체)',
  202: '아이템 상자(확률)',
  203: '아이템 상자(선택)',
  204: '아이템 상자(다중)',
  300: '일반 아이템 뽑기',
  301: '이벤트 래플 보상',
  302: '베이직 뽑기',
  303: '베이직 티켓 소모',
  400: '엔진 강화 재료 엔진',
  401: '엔진 강화 부품',
  402: '엔진 강화 프로텍터',
  403: '엔진 강화 결과 엔진',
  404: '엔진 강화 서포터',
  405: '엔진 서포터 업그레이드 사용',
  406: '엔진 서포터 업그레이드 추가',
  500: '서버 아이템 뽑기',
  501: '서버 아이템 보상',
  600: '파일럿 스킬 수치 변경',
  601: '파일럿 승급',
  602: '파일럿 코어 변환'
};

export const transactionStatus = {
  0: '-',
  1: '생성',
  2: '대기중',
  3: '완료',
  4: '실패',
  5: '취소',
  6: '완료된 역로그',
};

export const marketTransactionStatus = {
  0: '-',
  1: '등록 완료',
  2: '판매 완료',
  3: '취소됨',
  4: 'Pending',
};

export const rentalType = {
  0: '무료',
  1: '1일',
  2: '7일',
  3: '30일',
};

export const gearGrade = {
  1: 'GEAR1',
  2: 'GEAR10',
  3: 'GEAR100',
};

export const BasicAccountPointLogType = {
  1: '초대',
  2: '일일미션',
};

export const BasicGradeRewardLogType = {
  1: '등급 달성 보상',
  2: '친구 선물',
  3: '누적 친구 보상',
  4: '초대 코드 입력 보상',
};

export const BasicModeGrade = {
  1: 'Bronze',
  2: 'Silver',
  3: 'Gold',
  4: 'Platinum',
  5: 'Sapphire',
  6: 'Topaz',
  7: 'Emerald',
  8: 'Ruby',
  9: 'Diamond',
  10: 'Master',
};

export const BasicGradePointCut = {
  1: 0,
  2: 60,
  3: 280,
  4: 920,
  5: 2120,
  6: 4520,
  7: 6920,
  8: 9320,
  9: 11720,
  10: 14120,
};

/**
 *
 * @type public enum TokenType
 *     {
 *         HVH,
 *         PER,
 *         XPER,
 *         PERPLAY,
 *         GEAR,
 *         USDT,
 *         ARB,
 *
 *         CASH = 100,
 *         ITEM = 200,
 *     };
 */
export const TokenType = {
  0: 'HVH',
  1: 'PER',
  2: 'XPER',
  3: 'PERPLAY',
  4: 'GEAR',
  5: 'USDT',
  6: 'ARB',

  100: 'CASH',
  200: 'ITEM',
};

/**
 *  public enum ContentsIndex : int
 *     {
 *         NONE = 0,
 *         // 정의 참고: https://docs.google.com/spreadsheets/d/1Md5YhKqhi2IA2FlFr54u5rQ9sKh1lmClP6yeSeyCM3w/edit?gid=194244213#gid=194244213
 *         WORKSHOP_BREED = 301,
 *         WORKSHOP_GENESIS_BREED = 302,
 *         WORKSHOP_EVOLVE = 303,
 *         WORKSHOP_GEM_UPGRADE = 304,
 *         WORKSHOP_ENGINE_UPGRADE = 305,
 *         // NFT
 *         NFT_LEVEL_UP = 401,
 *         NFT_DISASSEMBLE = 406,
 *         // MARKET
 *         MARKET_BUY_NFT = 501,
 *         MARKET_BUY_NFT_BOX = 502
 *     }
 * }
 */

export const ContentsIndex = {
  0: 'NONE',
  301: '브리딩',
  302: '제네시스 브리딩',
  303: '이볼브',
  304: '보석 업그레이드',
  305: '엔진 업그레이드',
  401: 'NFT 레벨업',
  406: 'NFT 분해',
  501: 'NFT 구매',
  502: 'NFT 박스 구매',
};

const logDataAPI = {
  walletTransactionType: (type) => {
    if (walletTransactionType.hasOwnProperty(type)) {
      return walletTransactionType[type];
    }

    return notFound(type);
  },

  itemTransactionType: (type) => {
    if (itemTransactionType.hasOwnProperty(type)) {
      return itemTransactionType[type];
    }

    return notFound(type);
  },

  transactionStatus: (type) => {
    if (transactionStatus.hasOwnProperty(type)) {
      return transactionStatus[type];
    }

    return notFound(type);
  },

  marketTransactionStatus: (type) => {
    if (marketTransactionStatus.hasOwnProperty(type)) {
      return marketTransactionStatus[type];
    }

    return notFound(type);
  },

  nftRentalType: (type) => {
    if (rentalType.hasOwnProperty(type)) {
      return rentalType[type];
    }

    return notFound(type);
  },

  gearGrade: (grade) => {
    if (gearGrade.hasOwnProperty(grade)) {
      return gearGrade[grade];
    }

    return notFound(grade);
  },

  BasicAccountPointLogType: (type) => {
    if (BasicAccountPointLogType.hasOwnProperty(type)) {
      return BasicAccountPointLogType[type];
    }

    return notFound(type);
  },

  BasicModeGrade: (grade) => {
    if (BasicModeGrade.hasOwnProperty(grade)) {
      return BasicModeGrade[grade];
    }

    return notFound(grade);
  },

  BasicGradeRewardLogType: (type) => {
    if (BasicGradeRewardLogType.hasOwnProperty(type)) {
      return BasicGradeRewardLogType[type];
    }

    return notFound(type);
  },

  GetBasicGradeRewardValue: (type, value) => {
    if (BasicGradeRewardLogType.hasOwnProperty(type)) {
      switch (type) {
        case 1:
          return BasicModeGrade[value];
        case 2:
          return value;
        case 3:
          return value + ' 명';
        case 4:
          return '-';
        default:
          return value;
      }
    }
  },

  GetBasicGradePointCut: (point) => {
    for (let grade = 10; grade >= 1; grade--) {
      if (point >= BasicGradePointCut[grade]) {
        return BasicModeGrade[grade] + '(' + point + '점)';
      }
    }
    return 1; // 기본 등급, 0점 미만일 경우
  },

  TokenType: (type) => {
    if (TokenType.hasOwnProperty(type)) {
      return TokenType[type];
    } else {
      return 'NONE';
    }
  },

  ContentsIndex: (type) => {
    if (ContentsIndex.hasOwnProperty(type)) {
      return ContentsIndex[type];
    } else {
      return 'NONE';
    }
  },

  // status는 0: 준비 중, 1: 성공, 2: 실패
  GetStatus: (status) => {
    switch (status) {
      case 0:
        return '준비 중';
      case 1:
        return '성공';
      case 2:
        return '실패';
      default:
        return '알 수 없음';
    }
  },

  GetItemName: (type, materials) => {
    if (TokenType.hasOwnProperty(type) && type < 100) {
      return TokenType[type];
    } else {
      if (materials && materials.length > 0) {
        const item = materials.find((material) => material?.itemId === type);
        return (
            item ? item.itemName : "NONE"  +
            ' [' +
            type +
            ']'
        );
      }
    }
  },
};

export default logDataAPI;
